import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  EInvoiceTypePicker,
  EInvoiceTypePickerProps,
} from '@work4all/components/lib/components/entity-picker/e-invoice-type-picker/EInvoiceTypePicker';

import { EInvoiceType } from '@work4all/models/lib/Enums/EInvoiceType.enum';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<EInvoiceTypePickerProps, 'multiple' | 'value' | 'onChange'> {
  error?: string;
  value: EInvoiceType;
  onChange: (value: EInvoiceType) => void;
  disabled?: boolean;
  clearable?: boolean;
}

export const EInvoiceTypePickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const { error, clearable, disabled, ...pickerProps } = props;
    const { value, onChange } = pickerProps;

    return (
      <EntityPickerPopover
        picker={
          <EInvoiceTypePicker
            {...pickerProps}
            onChange={(value) => onChange(value)}
          />
        }
      >
        <PickerTargetButton
          ref={ref}
          onClear={
            clearable
              ? () => {
                  onChange(null);
                }
              : null
          }
          label={t('COMMON.E_INVOICE_TYPE')}
          error={error}
          value={value ? (t(`E_INVOICE_TYPE.${value}`) as string) : ''}
          disabled={disabled}
        />
      </EntityPickerPopover>
    );
  }
);
